import { UseQueryResult } from "react-query";

export const isLoading = (queries: UseQueryResult<any, unknown>[]) => {
    return queries.some((query) => query.isIdle || query.isFetching);
}